{
  "common": {
    "memberCenter": "회원센터",
    "points": "포인트",
    "level": "등급",
    "coupons": "쿠폰",
    "checkin": "출석체크",
    "history": "이력",
    "balance": "잔액",
    "expire": "만료",
    "confirm": "확인",
    "cancel": "취소",
    "loading": "로딩 중...",
    "noData": "데이터가 없습니다",
    "retry": "재시도",
    "success": "성공",
    "failed": "실패"
  },
  "points": {
    "earn": "{amount} 포인트 적립",
    "spend": "{amount} 포인트 사용",
    "balance": "현재 잔액: {amount} 포인트",
    "expired": "{amount} 포인트가 만료되었습니다",
    "estimated": "예상 (확인 대기 중)"
  },
  "level": {
    "current": "현재 등급: {name}",
    "nextLevel": "다음 등급: {name}",
    "progress": "다음 등급까지 {current}/{target}",
    "upgraded": "축하합니다! {name}(으)로 승급했습니다"
  },
  "coupon": {
    "claim": "받기",
    "claimed": "수령 완료",
    "expired": "만료됨",
    "used": "사용됨",
    "validUntil": "유효기간: {date}"
  },
  "checkin": {
    "today": "오늘 출석체크",
    "done": "출석 완료",
    "streak": "{days}일 연속 출석",
    "reward": "+{amount} 포인트"
  },
  "errors": {
    "network": "네트워크 오류, 다시 시도해주세요",
    "unauthorized": "로그인이 필요합니다",
    "serverError": "서버 오류, 잠시 후 다시 시도해주세요",
    "timeout": "요청 시간 초과"
  },
  "ui": {
    "memberCenter": {
      "loading": "로딩 중...",
      "avatarAlt": "회원 아바타",
      "pointsBalance": "내 포인트",
      "menuLabel": "회원 기능 메뉴",
      "menu": {
        "pointsDetail": "포인트 내역",
        "levelDetail": "등급 혜택",
        "coupons": "내 쿠폰",
        "referral": "친구 초대",
        "checkin": "매일 출석"
      }
    },
    "pointsDetail": {
      "title": "포인트 내역",
      "empty": "포인트 내역이 없습니다",
      "loading": "로딩 중...",
      "noMore": "더 이상 내역이 없습니다",
      "listLabel": "포인트 내역",
      "status": {
        "pending": "확인 대기",
        "active": "사용 가능",
        "used": "사용됨",
        "expired": "만료됨"
      }
    },
    "levelProgress": {
      "loading": "로딩 중...",
      "maxLevel": "최고 등급 도달",
      "progressLabel": "등급 진행도",
      "noBenefits": "혜택이 없습니다",
      "nextLevel": "다음 등급: {name}",
      "benefitsTitle": "내 혜택"
    },
    "couponList": {
      "title": "내 쿠폰",
      "tabsLabel": "쿠폰 분류",
      "listLabel": "쿠폰 목록",
      "empty": "쿠폰이 없습니다",
      "freeShipping": "무료 배송",
      "giftValue": "선물",
      "discountValue": "{value}% 할인",
      "type": {
        "discount": "할인 쿠폰",
        "cash": "캐시 쿠폰",
        "shipping": "배송 쿠폰",
        "gift": "선물 쿠폰"
      },
      "tab": {
        "claimable": "받기",
        "available": "사용 가능",
        "used": "사용됨",
        "expired": "만료됨"
      },
      "loadingClaimable": "로딩 중...",
      "noClaimable": "받을 수 있는 쿠폰이 없습니다",
      "claiming": "받는 중...",
      "claim": "받기",
      "stockInfo": "잔여 {remaining}장",
      "stockUnlimited": "무제한",
      "minOrder": "{amount} 이상 주문 시 사용 가능"
    },
    "referralShare": {
      "loading": "로딩 중...",
      "title": "친구 초대",
      "shareTitle": "친구 초대하고 포인트 받기",
      "shareText": "지금 가입하고 선물을 받아보세요!",
      "invitedCount": "초대 완료",
      "rewardPoints": "획득 포인트",
      "codeLabel": "내 초대 코드",
      "linkLabel": "초대 링크",
      "copy": "복사",
      "copyCode": "초대 코드 복사",
      "share": "공유",
      "rewardHint": "친구 1명 초대 시 {points} 포인트",
      "tabShare": "초대",
      "tabRecords": "초대 기록",
      "loadingRecords": "기록 로딩 중...",
      "noRecords": "초대 기록이 없습니다",
      "anonymousUser": "익명 사용자",
      "prevPage": "이전",
      "nextPage": "다음",
      "recordsLabel": "초대 기록 목록",
      "status": {
        "registered": "가입 완료",
        "first_order": "첫 주문 완료",
        "rewarded": "보상 지급 완료"
      }
    },
    "checkinCalendar": {
      "loading": "로딩 중...",
      "checking": "출석체크 중...",
      "checkin": "출석체크",
      "alreadyChecked": "오늘 출석 완료",
      "day": "{count}일",
      "title": "매일 출석",
      "streak": "{days}일 연속",
      "calendarLabel": "출석 달력",
      "rewardsTitle": "연속 출석 보상",
      "rewardsLabel": "보상 목록",
      "prevMonth": "이전 달",
      "nextMonth": "다음 달",
      "monthDays": "이번 달 출석 {count}일",
      "monthPoints": "이번 달 포인트",
      "weekday": {
        "sun": "일",
        "mon": "월",
        "tue": "화",
        "wed": "수",
        "thu": "목",
        "fri": "금",
        "sat": "토"
      }
    },
    "orderList": {
      "loading": "주문 로딩 중...",
      "title": "주문 내역",
      "noOrders": "주문 기록이 없습니다",
      "listLabel": "주문 기록 목록",
      "prevPage": "이전",
      "nextPage": "다음",
      "typePoints": "포인트",
      "typeGrowth": "성장치",
      "bizType": {
        "Order_Pay": "주문 결제",
        "Order_Refund": "주문 환불"
      },
      "status": {
        "pending": "확인 대기",
        "active": "적립 완료",
        "invalid": "무효",
        "used": "사용 완료",
        "expired": "만료"
      }
    },
    "addressManager": {
      "title": "내 주소",
      "add": "주소 추가",
      "empty": "등록된 주소가 없습니다",
      "default": "기본",
      "setDefault": "기본으로 설정",
      "edit": "수정",
      "delete": "삭제"
    },
    "accountSettings": {
      "title": "계정 설정",
      "dataExport": {
        "title": "내 데이터 내보내기",
        "desc": "모든 개인 데이터 사본을 다운로드합니다",
        "button": "내보내기 요청",
        "processing": "처리 중..."
      },
      "deleteAccount": {
        "title": "계정 삭제",
        "desc": "계정과 모든 관련 데이터를 영구적으로 삭제합니다",
        "button": "계정 삭제",
        "confirm": "이 작업은 되돌릴 수 없습니다. 모든 데이터가 영구 삭제됩니다.",
        "confirmButton": "삭제 확인",
        "cancel": "취소"
      }
    },
    "exchange": {
      "store": {
        "title": "포인트 상점",
        "myOrders": "교환 내역",
        "empty": "교환 가능한 상품이 없습니다",
        "points": "포인트",
        "stock": "재고",
        "back": "돌아가기",
        "redeem": "교환하기",
        "soldOut": "품절",
        "noOrders": "교환 내역이 없습니다",
        "status": { "pending": "배송 대기", "completed": "완료", "cancelled": "취소됨" }
      }
    },
    "message": {
      "center": { "title": "메시지", "empty": "메시지가 없습니다" },
      "type": { "system": "시스템", "marketing": "프로모션", "transaction": "거래", "activity": "활동" }
    },
    "checkout": {
      "points": { "title": "포인트 차감", "unit": "P", "available": "사용 가능", "deduct": "차감" },
      "coupon": { "title": "쿠폰", "none": "쿠폰 미사용" },
      "summary": { "order": "주문 금액", "discount": "할인", "total": "결제 금액" }
    },
    "profile": {
      "form": { "nickname": "닉네임", "avatar": "아바타 URL", "locale": "언어", "save": "저장", "saving": "저장 중..." }
    },
    "auth": {
      "login": {
        "emailLabel": "이메일",
        "passwordLabel": "비밀번호",
        "submit": "로그인",
        "createAccount": "계정 만들기",
        "forgotPassword": "비밀번호를 잊으셨나요?",
        "orDivider": "또는"
      },
      "register": {
        "emailLabel": "이메일",
        "passwordLabel": "비밀번호",
        "confirmPasswordLabel": "비밀번호 확인",
        "passwordHint": "8자 이상, 영문과 숫자 포함",
        "submit": "계정 만들기",
        "submitting": "생성 중...",
        "hasAccount": "이미 계정이 있으신가요? 로그인",
        "passwordMismatch": "비밀번호가 일치하지 않습니다"
      },
      "oauth": {
        "continueWith": "{provider}로 계속하기"
      },
      "verify": {
        "title": "이메일 인증",
        "description": "{email}(으)로 인증코드를 보냈습니다",
        "digitLabel": "{index}번째 자리",
        "resend": "인증코드 재전송",
        "resendCountdown": "재전송 ({countdown}초)",
        "backToRegister": "등록으로 돌아가기"
      },
      "forgot": {
        "title": "비밀번호 재설정",
        "description": "이메일을 입력하시면 인증코드를 보내드립니다.",
        "emailLabel": "이메일",
        "submit": "코드 전송",
        "backToLogin": "로그인으로 돌아가기"
      }
    }
  },
  "sdk": {
    "error": {
      "210900": "매개변수 오류",
      "210901": "테넌트 ID가 필요합니다",
      "210902": "요청 빈도 초과, 잠시 후 다시 시도해주세요",
      "210903": "미인증",
      "210904": "토큰이 만료되었습니다",
      "210905": "유효하지 않은 토큰",
      "210906": "토큰 갱신 실패",
      "210907": "플랫폼 토큰 교환 실패",
      "210908": "유효하지 않은 리프레시 토큰",
      "210909": "리프레시 토큰이 만료되었습니다",
      "210911": "회원을 찾을 수 없습니다",
      "210912": "회원 등급 정보를 찾을 수 없습니다",
      "210920": "이 이메일은 이미 등록되어 있습니다",
      "210921": "비밀번호 강도 부족: 8자 이상, 영문과 숫자 포함 필요",
      "210922": "인증 코드 전송이 너무 빈번합니다, 잠시 후 다시 시도해주세요",
      "210923": "인증 코드가 잘못되었거나 만료되었습니다",
      "210924": "등록 정보가 만료되었습니다, 다시 등록해주세요",
      "210925": "이메일 또는 비밀번호가 올바르지 않습니다",
      "210926": "이메일 미인증, 먼저 인증을 완료해주세요",
      "210927": "OAuth 인증 실패",
      "210928": "OAuth state가 유효하지 않거나 만료되었습니다",
      "210929": "지원하지 않는 로그인 방식입니다",
      "210930": "사용자 생성 실패",
      "210931": "할인 계산 실패",
      "210951": "포인트 잔액 조회 실패",
      "210952": "포인트 거래 조회 실패",
      "210953": "포인트 획득 실패",
      "210954": "포인트 활성화 실패",
      "210955": "포인트 소비 실패",
      "210956": "포인트 잔액 부족",
      "210957": "포인트 기록을 찾을 수 없습니다",
      "210958": "포인트 상태가 이 작업을 허용하지 않습니다",
      "210971": "쿠폰이 소진되었습니다",
      "210972": "이미 받은 쿠폰입니다",
      "210981": "메시지 큐 쓰기 실패",
      "210982": "내부 서비스 동기화 실패",
      "210983": "교환 상품을 찾을 수 없습니다",
      "210984": "교환 실패",
      "210985": "초대 코드를 찾을 수 없습니다",
      "210986": "초대자 바인딩 실패",
      "210987": "초대자를 찾을 수 없습니다",
      "210988": "자신을 초대할 수 없습니다",
      "210989": "쿠폰 받기 실패",
      "210990": "오늘 이미 출석했습니다",
      "210991": "출석 실패",
      "211900": "작업에 실패했습니다. 다시 시도해주세요",
      "211901": "인증에 실패했습니다",
      "211902": "이 계정은 관리 권한에 바인딩되지 않았습니다",
      "211903": "작업 권한이 없습니다",
      "211904": "설정 항목을 찾을 수 없습니다",
      "211905": "설정 범위가 잘못되었���니다",
      "211906": "역할을 찾을 수 없습니다",
      "211907": "시스템 역할은 삭제할 수 없습니다",
      "211908": "관리자에게 이 테넌트에 대한 접근 권한이 없습니다",
      "211909": "매개변수 검증 실패",
      "211910": "리소스를 찾을 수 없습니다",
      "211911": "회원 정보를 찾을 수 없습니다",
      "211912": "신원 충돌, 고객센터로 문의해주세요",
      "211913": "섀도우 계정 활성화 실패",
      "211914": "심사 기록을 찾을 수 없습니다",
      "211915": "심사 기록 상태가 대기 중이 아닙니다",
      "211916": "OneID를 찾을 수 없습니다",
      "211917": "OneID 연결 해제 실패",
      "211931": "등급 설정을 찾을 수 없습니다",
      "211932": "등급에 연결된 회원이 있어 삭제할 수 없습니다",
      "211933": "승급 조건 검증 실패",
      "211934": "등급 순서는 연속적이어야 합니다",
      "211951": "포인트 상태 전환이 잘못되었습니다",
      "211952": "포인트 잔액 부족",
      "211953": "포인트 기록을 찾을 수 없습니다",
      "211954": "포인트 거래 중복",
      "211955": "포인트 소비 수량이 유효하지 않습니다",
      "211956": "포인트 차감이 최대 비율을 초과했습니다",
      "211957": "포인트가 최소 소비 임계값에 도달하지 않았습니다",
      "211958": "포인트 획득 규칙이 설정되지 않음",
      "211959": "포인트 활성화 실패: 상태가 대기 중이 아닙니다",
      "211960": "포인트 거래 조회 권한 없음",
      "211961": "포인트 만료 처리 완료",
      "211962": "성장값 규칙이 설정되지 않음",
      "211971": "쿠폰 템플릿을 찾을 수 없습니다",
      "211972": "쿠폰 템플릿 상태가 발급 가능하지 않습니다",
      "211973": "쿠폰 사용자별 수령 한도 초과",
      "211974": "쿠폰 총 발급량 초과",
      "211975": "쿠폰 사용 상태가 유효하지 않습니다",
      "211976": "쿠폰이 만료되었습니다",
      "211977": "쿠폰 템플릿이 발급되어 삭제할 수 없습니다",
      "211981": "푸시 작업을 찾을 수 없습니다",
      "211982": "푸시 작업 상태가 편집을 허용하지 않습니다",
      "211983": "푸시 작업 상태가 취소를 허용하지 않습니다",
      "211984": "푸시 템플릿을 찾을 수 없습니다",
      "211985": "푸시 대상이 비어 있습니다",
      "211991": "서비스 혼잡, 잠시 후 다시 시도해주세요",
      "211992": "메시지 발행 실패",
      "211993": "메시지가 데드레터 큐에 들어갔습니다",
      "211001": "Webhook 서명 검증 실패",
      "211002": "지원하지 않는 Webhook 플랫폼",
      "211003": "Webhook 요청 중복",
      "211004": "Webhook Secret 미설정",
      "211005": "Webhook 타임스탬프 만료",
      "network": "네트워크 오류, 연결을 확인해주세요",
      "timeout": "요청 시간 초과, 다시 시도해주세요",
      "aborted": "요청이 취소되었습니다",
      "parse": "응답 파싱 오류",
      "unauthorized": "로그인이 필요합니다",
      "config": "SDK 초기화 오류",
      "unknown": "알 수 없는 오류가 발생했습니다"
    }
  }
}
